import React, { MouseEventHandler, ReactNode } from 'react';
import { ControllerFieldState, ControllerRenderProps } from 'react-hook-form/dist/types/controller';
import {
  FormControl,
  FormControlLabel,
  FormHelperText, Switch,
} from '@material-ui/core';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { getFinalErrorMessage } from 'lib/form/FormUtils';
import { UseFormStateReturn } from 'react-hook-form/dist/types';

type Props = {
  control: {
    field: ControllerRenderProps<any, any>,
    fieldState: ControllerFieldState,
    formState: UseFormStateReturn<any>,
  },
  label: ReactNode
  error: FieldErrors,
  apiErrors?: { [key: string]: string[] },
  onClick?: MouseEventHandler,
  onChange?: (value: string) => void,
  changeDisable?: boolean,
  disabled?: boolean,
};

export default function SwitchWrapper(
  {
    control,
    label,
    error,
    apiErrors,
    onClick,
    onChange,
    changeDisable,
    disabled,
  }: Props,
) {
  const { field } = control;
  const errorMessage = getFinalErrorMessage(field.name, error, apiErrors);

  const changeValue = (value: boolean) => {
    if (!changeDisable) {
      if (onChange) {
        onChange(value.toString());
      }
      field.onChange(value);
    }
  };

  return (
    <div className="switch-wrapper">
      <FormControl
        error={!!errorMessage}
        disabled={disabled}
      >
        <FormControlLabel
          control={(
            <Switch
              {...field}
              value={!!field.value}
              checked={!!field.value}
              onClick={onClick}
              disabled={disabled}
              onChange={(e) => {
                const { checked } = e.target;
                changeValue(checked);
              }}
            />
          )}
          label={label}
        />
        {!!errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
      </FormControl>
    </div>
  );
}
